import * as React from 'react';
import PageTitle from '../../module/pageTitle';
import LabelInput from '../../Component/labelInput';
import DropDown from '../../Component/dropdown';
import DatePicker from '../../Component/datePicker';
import moment from "moment";
import { Submitbtn } from '../../Component';
import AdminTable from '../../Component/adminTable';

const ActiveUsers = () => {

    const renderTable = () => {
        return (
            <div className="admin-table table-responsive-md table-responsive">
                <table className="table table-striped table-hover align-middle text-md-start text-center">
                    <thead className=''>
                        <tr>
                            <th>S.N</th>
                            <th>Exam Name</th>
                            <th>Exam Stream</th>
                            <th>Month</th>
                            <th>Live</th>
                            <th>Recorded</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <td>CSIRNET</td>
                            <td>Life Science</td>
                            <td>Jan</td>
                            <td>824</td>
                            <td>807</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"Active Users"}
                    breadCrumb={""}
                    isEditMode={""}
                    cancelEdit={() => ('')} />
            </div>
            <div className='formDiv'>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    <form>
                        <div className="row">
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Start Date"} />
                                <DatePicker
                                    value={''}
                                    setInputText={(value: any) => ('')}
                                    // Isrequired={true}
                                    defaultValue={''}
                                    maxdate={moment.utc(new Date()).format("YYYY-MM-DD")}
                                    mindate={""}
                                    disabled={false}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"End Date"} />
                                <DatePicker
                                    value={''}
                                    setInputText={(value: any) => ('')}
                                    // Isrequired={true}
                                    defaultValue={''}
                                    maxdate={moment.utc(new Date()).format("YYYY-MM-DD")}
                                    mindate={""}
                                    disabled={false}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Exam Name"} />
                                <DropDown
                                    labelName={"Select Exam Name"}
                                    setInputText={(value: any) => ("")}
                                    options={""}
                                    value={""}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Exam Stream"} />
                                <DropDown
                                    labelName={"Select Exam Stream"}
                                    setInputText={(value: any) => ("")}
                                    options={""}
                                    value={''}
                                />
                            </div>
                            <div className='col-md-2 ms-auto'>
                                <Submitbtn name={"Search"} disabled={false} />
                            </div>
                        </div>
                    </form >
                </div>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    {renderTable()}
                </div>

            </div>
        </div>
    );
}

export default ActiveUsers;